import { useNavigate } from "react-router-dom";
import { get } from "../server";
import { GET_USER } from "../utils/constants/apiUrl";
import {
  teamIDCheck,
  subscribedPackage,
  teamSubscribedPackage,
  loggedInUser,
  accountType,
  isOwnerPackage,
  userIDCheck,
  subscriptionPackages,
} from "../utils/store";

import { useAtom } from "jotai";
import showToast from "../helpers/showToast";
import useFunctionsCount from "./useFunctionsCount";
import { normalizePackageDetails } from "../utils/functions";

const useRefreshUser = () => {
  const navigate = useNavigate();
  const [loggedUser, setLoggedUser] = useAtom(loggedInUser);
  const [userTeamId, setUserTeamId] = useAtom(teamIDCheck);
  const [purchasedPackage, setPurchasedPackage] = useAtom(subscribedPackage);
  const [teamPurchasedPackage, setTeamPurchasedPackage] = useAtom(teamSubscribedPackage);
  const [personalAccount, setPersonalAccount] = useAtom(accountType);
  const [purchasePackages] = useAtom(subscriptionPackages);
  const [isOwnerPackageActive, setIsOwnerPackageActive] =
    useAtom(isOwnerPackage);
  const [userID, setUserID] = useAtom(userIDCheck);
  const { userActions } = useFunctionsCount();

  const getUser = async () => {
    let { status, message, data } = await get(
      GET_USER,
      Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
    );

    if (status) {
      data.token = loggedUser.token;
      data = normalizePackageDetails(data);
      handleStates(data);
    }
  };

  const handleStates = (userData) => {
    const withTeamIdData = userData?.secret_code?.filter(
      (item) => item.team_id !== null
    );
    const connectedTeams = userData?.connected_teams;
    const connectedTeamId = Array.isArray(connectedTeams)
      ? connectedTeams[0]?.id
      : connectedTeams?.id;

    if (personalAccount) {
      let teamPackage = userData?.package_details?.find(
        (obj) => obj.team_id == null
      );

      setLoggedUser(userData);
      userActions(userData);

      setIsOwnerPackageActive(false);
      const personalPackagePlan = purchasePackages.find(p => p.id == teamPackage?.package_id) || teamPackage?.package || teamPackage;
      setPurchasedPackage(personalPackagePlan);
      
      // Persist to localStorage
      if (personalPackagePlan && Object.keys(personalPackagePlan).length > 0) {
        localStorage.setItem("purchasedPackage", JSON.stringify(personalPackagePlan));
      }
      
      setUserTeamId(null);
      setPersonalAccount(true);
      // navigate("/");
    } else {
      // check if two roles and include team owner
      if (userData?.role?.includes("team_owner")) {
        let teamID = withTeamIdData[0]?.team_id;
        let isTeamPackage = userData?.package_details.filter(
          (obj) => obj.team_id == teamID
        );

        const isExpired = isTeamPackage[0]?.end_date && new Date() >= new Date(isTeamPackage[0].end_date);
        if (isTeamPackage.length <= 0 || isExpired) {
          navigate("/paymentNotPaid");
        }

        let teamPackage = userData?.package_details?.find(
          (obj) => obj.team_id == teamID
        );
        setIsOwnerPackageActive(true);
        const teamPackagePlan = purchasePackages.find(p => p.id == teamPackage?.package_id) || teamPackage?.package || teamPackage;
        setPurchasedPackage(teamPackagePlan);
        setTeamPurchasedPackage(teamPackagePlan);
        
        // Persist to localStorage
        if (teamPackagePlan && Object.keys(teamPackagePlan).length > 0) {
          localStorage.setItem("teamPurchasedPackage", JSON.stringify(teamPackagePlan));
          localStorage.setItem("purchasedPackage", JSON.stringify(teamPackagePlan));
        }
        
        setUserTeamId(teamID);
        setPersonalAccount(false);
        setUserID(userData?.teams?.user_id);
      } else {
        const isSuspended = userData?.team_members?.some(
          (member) => member.check_status === "suspended"
        );
        if (isSuspended) {
          showToast(
            false,
            "Your account has been suspended by admin, please contact support for further queries"
          );
        } else {
          let teamID = withTeamIdData[0]?.team_id || connectedTeamId;
          let isTeamPackage = userData?.package_details.filter(
            (obj) => obj.team_id == teamID
          );

          const isExpired = isTeamPackage[0]?.end_date && new Date() >= new Date(isTeamPackage[0].end_date);
          if (isTeamPackage.length <= 0 || isExpired) {
            return showToast(
              false,
              "You can not switch to team mode because your team is not subscribed to any package"
            );
          }
          let teamPackage = userData?.package_details?.find(
            (obj) => obj.team_id == teamID
          );
          const teamPackagePlan = purchasePackages.find(p => p.id == teamPackage?.package_id) || teamPackage?.package || teamPackage;
          setPurchasedPackage(teamPackagePlan);
          setTeamPurchasedPackage(teamPackagePlan);
          
          // Persist to localStorage
          if (teamPackagePlan && Object.keys(teamPackagePlan).length > 0) {
            localStorage.setItem("teamPurchasedPackage", JSON.stringify(teamPackagePlan));
            localStorage.setItem("purchasedPackage", JSON.stringify(teamPackagePlan));
          }
          
          setUserTeamId(teamID);
          setPersonalAccount(false);
          // navigate("/");
        }
      }
    }
  };

  const refreshUser = () => {
    getUser();
  };
  return { refreshUser };
};

export default useRefreshUser;
